export const STORAGE_KEYS = {
  REFRESH_TOKEN: 'RFTKN',
  TOKEN: 'TKN',
  ONBOARDING_COMPLETED: 'ONBOARDING_COMPLETED',
}
